'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-929adab5.js');
var React = require('react');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var Container = styled__default["default"].div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 3px;\n"], ["\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 3px;\n"])));
var TabsContainer = styled__default["default"].ul(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  padding: 0;\n  margin: 0;\n  align-items: center;\n  list-style: none;\n"], ["\n  display: flex;\n  flex-direction: row;\n  padding: 0;\n  margin: 0;\n  align-items: center;\n  list-style: none;\n"])));
var NavigationBar = function (_a) {
    var className = _a.className, children = _a.children;
    return (React__default["default"].createElement(Container, { className: className },
        React__default["default"].createElement(TabsContainer, null, children)));
};
var templateObject_1, templateObject_2;

exports["default"] = NavigationBar;
